/* ============================================================
   ERO GLOW BUTTON - lit state and glass sweep (Launch Workbook 6.14.18)

   Every .ero-glow-btn glows on hover at desktop and on press on touch,
   with one pass of the glass sweep. So do the hand-built cart drawer CTAs
   (Checkout, Shop ERO Elevate, the bundle nudge Add, the add-on CTA) and
   the footer JOIN, so all 28 site CTAs behave the same (part 2). The look lives in
   assets/component-glow-button.css; this file only:
   - inserts two aria-hidden layers (__lit, __fx > __sheen) the first
     time a button is hovered or pressed, so sections re-rendered by the
     cart or the theme editor need no setup;
   - sizes them to the button's __inner every time it lights, so they
     follow its radius and box at any breakpoint (some sections give the
     button a larger radius than its ring);
   - on touch, adds is-glow-pressed on press and removes it on release
     (the CSS then fades out over 1s); a scroll that cancels the press
     fades fast instead (is-glow-cancel).
   Pointer Events only, delegated from the document, passive listeners.
   ============================================================ */
(function () {
  'use strict';

  var SEL = '.ero-glow-btn, .ero-cart__cta, .ero-cart__nudge-add, .ero-cart__addon-cta, .ero-footer__email-btn';
  // The ring each host draws, which the layers copy. JOIN draws its ring
  // on the button itself.
  var RING = ['ero-glow-btn__inner', 'ero-cart__glow'];
  var pressed = null;
  var cancelTimer = null;

  function blocked(btn) {
    return btn.disabled ||
      btn.getAttribute('aria-disabled') === 'true' ||
      btn.getAttribute('aria-busy') === 'true' ||
      btn.classList.contains('is-added');
  }

  function innerOf(btn) {
    for (var i = 0; i < btn.children.length; i++) {
      for (var j = 0; j < RING.length; j++) {
        if (btn.children[i].classList.contains(RING[j])) return btn.children[i];
      }
    }
    return btn.matches('.ero-footer__email-btn') ? btn : null;
  }

  // Layers go BEFORE the ring so they paint under it and under the label.
  // When the host is its own ring (JOIN) they go first, and its CSS keeps
  // them under the text.
  function ensure(btn) {
    var inner = innerOf(btn);
    if (!inner) return null;
    btn.classList.add('ero-glow-host');
    var g = btn._eroGlow;
    if (g && g.lit.parentNode === btn && g.inner === inner) return g;
    var lit = document.createElement('span');
    lit.className = 'ero-glow-btn__lit';
    lit.setAttribute('aria-hidden', 'true');
    var fx = document.createElement('span');
    fx.className = 'ero-glow-btn__fx';
    fx.setAttribute('aria-hidden', 'true');
    var sheen = document.createElement('span');
    sheen.className = 'ero-glow-btn__sheen';
    fx.appendChild(sheen);
    var before = inner === btn ? btn.firstChild : inner;
    btn.insertBefore(lit, before);
    btn.insertBefore(fx, before);
    g = btn._eroGlow = { inner: inner, lit: lit, fx: fx };
    return g;
  }

  function fit(g) {
    var i = g.inner;
    var self = i === g.lit.parentNode;
    var r = window.getComputedStyle(i).borderRadius;
    [g.lit, g.fx].forEach(function (n) {
      // A self-ring host: cover its border box from inside its padding box.
      n.style.top = (self ? -i.clientTop : i.offsetTop) + 'px';
      n.style.left = (self ? -i.clientLeft : i.offsetLeft) + 'px';
      n.style.width = i.offsetWidth + 'px';
      n.style.height = i.offsetHeight + 'px';
      n.style.borderRadius = r;
    });
  }

  function sweep(g) {
    g.fx.classList.remove('is-sweep');
    void g.fx.offsetWidth; // restart the one-pass animation
    g.fx.classList.add('is-sweep');
  }

  function light(btn) {
    if (blocked(btn)) return null;
    var g = ensure(btn);
    if (!g) return null;
    fit(g);
    sweep(g);
    return g;
  }

  function release(cancelled) {
    if (!pressed) return;
    var btn = pressed;
    pressed = null;
    if (cancelled) {
      btn.classList.add('is-glow-cancel');
      if (btn._eroGlow) btn._eroGlow.fx.classList.remove('is-sweep');
      clearTimeout(cancelTimer);
      cancelTimer = setTimeout(function () { btn.classList.remove('is-glow-cancel'); }, 200);
    }
    btn.classList.remove('is-glow-pressed');
  }

  // Desktop: light on entry. The glow itself is CSS :hover.
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var btn = e.target.closest && e.target.closest(SEL);
    if (!btn || (e.relatedTarget && btn.contains(e.relatedTarget))) return;
    light(btn);
  }, { passive: true });

  // Touch and pen: press lights, release fades slowly.
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse') return;
    var btn = e.target.closest && e.target.closest(SEL);
    if (!btn) return;
    release(false);
    if (!light(btn)) return;
    btn.classList.remove('is-glow-cancel');
    btn.classList.add('is-glow-pressed');
    pressed = btn;
  }, { passive: true });

  document.addEventListener('pointerup', function () { release(false); }, { passive: true, capture: true });
  document.addEventListener('pointercancel', function () { release(true); }, { passive: true, capture: true });
})();
